import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useConfrimCookie from "shared/model/useConfrimCookie"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetManagerId = () => {
    const [fetchResult, fetchRequest] = useFetch()
    const [, , deleteConfrimCookie] = useConfrimCookie()
    const [, setAlert] = useAlertModalAtom()

    const request = () => {
        fetchRequest("GET", "/admin/auth/manager/id")
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 404:
                if (fetchResult?.data?.error_code === 1) {
                    setAlert("가입된 계정이 아닙니다.")
                    deleteConfrimCookie()
                }
                break

        }
    }, [fetchResult])


    return [fetchResult, request]
}

export default useGetManagerId